import React from 'react';
import { FiPlus } from 'react-icons/fi';

const DiscountHeader = ({ onAddDiscount }) => {
  return (
    <div className="px-6 py-4 border-b border-gray-200 flex justify-between items-center">
      <div>
        <h2 className="text-xl font-semibold text-gray-800">Discounts & Offers</h2>
        <p className="text-sm text-gray-500">Manage promotional discounts and special offers</p>
      </div>
      <button
        onClick={onAddDiscount}
        className="flex items-center px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700"
      >
        <FiPlus className="mr-2" /> Create Discount
      </button>
    </div>
  );
};

export default DiscountHeader;